<template>
  <div class="video-detail" v-if="video">
      <div class="video-container">
        <iframe
         :src="videoUrl"
          frameborder="0"
          allowfullscreen
          >
         </iframe>
      </div>
  </div>
</template>

<script>
//?autoplay=1&mute=1 //자동 재생 주소뒤에 추가
export default {
    name: 'VideoListItemDetail',
    props: {
        video: Object,
    },
    computed: {
        videoUrl() {
            const videoId = this.video.id.videoId
            return `https://www.youtube.com/embed/${videoId}`
        },
    },
}
</script>

<style>
.video-detail {
    width: 100%;
    padding: 1rem;
}
.video-container {
    position: relative;
    padding-top: 56.25%
}
.video-container > iframe {

    position: absolute;
    top: 0;
    left: 0;
    width: 100%;
    height: 100%;
}

</style>